import { forwardRef, Ref, type SVGProps } from 'react';

const SvgCaretIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 16"
    ref={ref}
    {...props}
  >
    <path stroke="currentColor" strokeWidth={5} d="m2.5 2.75 9.5 9.5 9.5-9.5" />
  </svg>
);
const ForwardRef = forwardRef(SvgCaretIcon);
export default ForwardRef;
